import styled, {
  animatedShadowOnHover,
  BoxShadows,
  breakpoints,
  Device,
  IFalconTheme,
  Image,
  ResponsiveTypography,
  Scale,
  StyledComponent,
} from '@se-admin/falcon';
import { SaleCardVariant } from '../SaleCard/SaleCard.interfaces';

const BOOKING_IMAGE_RATIO_PERCENTAGE: number = 66.66;
const BOOKING_IMAGE_MIN_WIDTH: number = 290;
const BOOKING_IMAGE_MAX_WIDTH: number = 324;
const BOOKING_DETAILS_MIN_WIDTH: number = 330;

export const BookingCardWrapper: StyledComponent<'div', IFalconTheme> = styled('div')`
  cursor: pointer;
  position: relative;
  border-radius: ${Scale.xxs};
  box-sizing: border-box;
  padding: 0;
  margin-bottom: ${Scale.l};
  @media only screen and (min-width: ${breakpoints[Device.tablet]}) {
    display: -ms-grid;
    display: grid;
    width: 100%;
    -ms-grid-rows: auto auto;
    grid-template-rows: auto auto;
    -ms-grid-columns: minmax(${BOOKING_IMAGE_MIN_WIDTH}px, ${BOOKING_IMAGE_MAX_WIDTH}px) ${Scale.s}
      minmax(${BOOKING_DETAILS_MIN_WIDTH}px, 1fr);
    grid-template-columns: minmax(${BOOKING_IMAGE_MIN_WIDTH}px, ${BOOKING_IMAGE_MAX_WIDTH}px) ${Scale.s} minmax(
        ${BOOKING_DETAILS_MIN_WIDTH}px,
        1fr
      );
  }
  ${animatedShadowOnHover(BoxShadows.level2, BoxShadows.level4)}
  ${({ theme }) =>
    `font-family: ${theme.fontFamilyBody.join()};
     background: ${theme.color.white};`};

  &::after {
    content: '';
    clear: both;
    display: table;
  }
`;

interface IImageContainerProps {
  variant: SaleCardVariant;
  theme?: IFalconTheme;
}

export const ImageContainer: StyledComponent<'div', IFalconTheme, IImageContainerProps> = styled(
  'div'
)`
  ${({ theme }: IImageContainerProps) =>
    `@media only screen and (min-width: ${breakpoints[Device.tablet]}) {
      display: block;
      height: 0;
      padding-bottom: ${BOOKING_IMAGE_RATIO_PERCENTAGE}%;
      background-color: ${theme.color.grey20};
      border-radius: ${Scale.xxs} 0 0 ${Scale.xxs};
    }
    @media only screen and (max-width: ${breakpoints[Device.tablet]}) {
      border-radius: ${Scale.xxs} ${Scale.xxs} 0 0;
    }
  `}
`;

export const CustomNormalImage: StyledComponent<typeof Image, {}, {}> = styled(Image)`
  top: 0;
  left: 0;
  border-top-left-radius: ${Scale.xxs};

  @media only screen and (min-width: ${breakpoints[Device.tablet]}) {
    border-bottom-left-radius: ${Scale.xxs};
  }
  @media only screen and (max-width: ${breakpoints[Device.tablet]}) {
    border-top-right-radius: ${Scale.xxs};
  }
`;

export const CustomDetailLine: StyledComponent<'div', IFalconTheme> = styled('div')`
  padding-top: ${Scale.xs};
  padding-bottom: ${Scale.l};
`;

export const ContentContainer: StyledComponent<'div', IFalconTheme> = styled('div')`
  display: block;
  padding: ${Scale.m};
  @media only screen and (min-width: ${breakpoints[Device.tablet]}) {
    -ms-grid-row: 2;
    grid-row-start: 2;
    -ms-grid-row-span: 1;
    grid-row-end: 3;
    -ms-grid-column: 3;
    grid-column-start: 3;
    -ms-grid-column-span: 1;
    grid-column-end: 3;
    padding: ${Scale.l};
  }
`;

export const BookingLabelsContainer: StyledComponent<'div', IFalconTheme, {}> = styled('div')`
  display: block;
`;

export const AmendedDatesText: StyledComponent<typeof ResponsiveTypography, {}> = styled(
  ResponsiveTypography
)`
  text-decoration: line-through;
`;
